import { render, staticRenderFns } from "./CreateOtherSupplierPopUp.vue?vue&type=template&id=be0e479a&scoped=true&"
import script from "./CreateOtherSupplierPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOtherSupplierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherSupplierPopUp.vue?vue&type=style&index=0&id=be0e479a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0e479a",
  null
  
)

export default component.exports